
<div class="img_file_wrapper">
    <form class="dropzone needsclick imgfile" id="img-files" action="/upload" style="max-height : 243px;">
        <div class="profile_thumbnail" v-if="detailDropzone != null">
            <a href="javascript:void(0);" title="">
                <div class="thumbnail_img">
                    <img v-bind:src="detailDropzone.url" alt="첨부파일 미리보기 이미지" style="width:200px; height:213px;">
                </div>
                <span class="thumbnail_tit">{{detailDropzone.name}}</span>
            </a>
            <button type="button" class="btn btn_del"  style="color:white;">삭제</button>
        </div> 
     
    </form>	  
</div>
